document.addEventListener("DOMContentLoaded", function () {
  let swiper; // Declare swiper instance outside to allow reinitialization

  function initializeSwiper() {
    const swiperElement = document.querySelector(".flaunt-dynamic-carousel-container .swiper");
    if (swiperElement) {
      console.log("Swiper element found:", swiperElement);

      // Destroy existing swiper instance if it exists (for reinitialization)
      if (swiper) {
        swiper.destroy(true, true);
      }

      // Initialize Swiper
      swiper = new Swiper(swiperElement, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        centeredSlides: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".flaunt-dynamic-carousel-next",
          prevEl: ".flaunt-dynamic-carousel-prev",
        },
        pagination: {
          el: ".flaunt-dynamic-carousel-pagination",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.3, // Adjust for tablets
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4, // Adjust for desktops
            spaceBetween: 24, // Spacing for desktop
          },
        },
        updateOnWindowResize: true, // Update Swiper when window resizes
        observer: true, // Observe Swiper element for changes
        observeParents: true, // Observe parent container for changes
      });

      // Ensure Swiper updates after initialization
      window.addEventListener("load", function () {
        if (swiper) swiper.update();
      });

      console.log("Swiper initialized:", swiper);
    } else {
      console.error("Swiper element not found!");
    }
  }

  // Initialize Swiper on page load
  initializeSwiper();

  // Reinitialize Swiper when Shopify sections load (for AJAX navigation)
  document.addEventListener("shopify:section:load", function () {
    console.log("Shopify section loaded. Reinitializing Swiper...");
    initializeSwiper();
  });

  // Clean up Swiper when section unloads (optional)
  document.addEventListener("shopify:section:unload", function () {
    console.log("Shopify section unloaded.");
    if (swiper) {
      swiper.destroy(true, true); // Destroy Swiper instance on section unload
      swiper = null;
    }
  });
});